import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from "react";
export var useHasScroll = function useHasScroll() {
  /* Check if the scrollbar has an offset. */
  var hasScroll = function hasScroll() {
    return Boolean(window.scrollY);
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      scroll = _useState2[0],
      setScroll = _useState2[1];

  useEffect(function () {
    var onScroll = function onScroll() {
      /* Update the state when the scroll position changes. */
      scroll !== hasScroll() && setScroll(hasScroll());
    };
    /* Set the initial scroll state. */


    onScroll();
    document.addEventListener("scroll", onScroll);
    return function () {
      /* Clean up the event listener. */
      document.removeEventListener("scroll", onScroll);
    };
  }, [scroll, setScroll]);
  return scroll;
};